// Libraries.
import { useDispatch } from "react-redux";
// Slice.
import { openModal } from "./modalSlice";
import Button from "../../components/Button";

export const ModalButton: React.FC = () => {
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(openModal());
  };

  return (
    <Button className="contact-us" onClick={handleClick}>
      Contáctanos
    </Button>
  );
};
